import { useEffect, useState } from "react";
import { api, apiBase, type Stats } from "../api";

export default function Dashboard() {
  const [stats, setStats] = useState<Stats | null>(null);
  const [health, setHealth] = useState<string>("checking…");

  useEffect(() => {
    api
      .stats()
      .then(setStats)
      .catch((e) => setHealth(`API unreachable: ${e.message}`));
    api
      .health()
      .then((h) => setHealth(h.ok ? "Worker connected" : "Worker unhealthy"))
      .catch((e) => setHealth(`Worker unreachable: ${e.message}`));
  }, []);

  return (
    <div>
      <h2>Dashboard</h2>
      <p className="muted">
        API base: <code>{apiBase()}</code> &middot; {health}
      </p>
      <div className="stats-grid">
        {stats ? (
          <>
            <div className="stat"><div className="value">{stats.jobs}</div><div className="label">Jobs tracked</div></div>
            <div className="stat"><div className="value">{stats.new_jobs}</div><div className="label">New jobs</div></div>
            <div className="stat"><div className="value">{stats.outreach_drafts}</div><div className="label">Outreach drafts</div></div>
            <div className="stat"><div className="value">{stats.outreach_sent}</div><div className="label">Emails sent</div></div>
            <div className="stat"><div className="value">{stats.contacts}</div><div className="label">Contacts found</div></div>
          </>
        ) : (
          <div className="stat"><div className="value">—</div><div className="label">Loading</div></div>
        )}
      </div>
      <div className="card">
        <h3>Pipeline</h3>
        <p className="muted">
          The daily Worker cron tick (09:00 UTC) signals the agent runner via{" "}
          <code>JOBHUNTER_AGENT_WEBHOOK</code> or the runner's own schedule. The runner
          harvests jobs from your enabled sources, scores them with the multi-model router,
          finds decision-makers, and drafts outreach for your approval here.
        </p>
        <ul className="muted">
          <li>Jobs &rarr; review scored listings</li>
          <li>Outreach &rarr; approve or edit drafts before Gmail sends</li>
          <li>Searches &rarr; configure what the agent hunts for</li>
          <li>Settings &rarr; sources, LLM routing, Gmail, storage</li>
        </ul>
      </div>
    </div>
  );
}